import { Pipe, PipeTransform } from '@angular/core';
import { IonSlides } from '@ionic/angular';
import { DataService } from '../services/data.service';

@Pipe({
  name: 'imgDivider'
})
export class ImgDividerPipe implements PipeTransform {

  constructor(private dataServ: DataService) { }

  async transform(img: HTMLImageElement, slider: IonSlides): Promise<number> {

    const delay = (timeout: number) => new Promise((resolve) => {
      setTimeout(() => {
        resolve(true);
      }, timeout);
    });

    await delay(600);

    let WIDTH = window.innerWidth;
    let RATIO = img.height / img.naturalHeight;

    let VAL = Math.floor((img.naturalWidth * RATIO) / WIDTH);

    if (isNaN(VAL)) {
      WIDTH = window.innerWidth;
      RATIO = img.height / img.naturalHeight;
      this.dataServ.refresh = true;
      await delay(500);
      this.dataServ.refresh = false;

      VAL = Math.floor((img.naturalWidth * RATIO) / WIDTH);
    }

    slider.update();

    VAL = VAL > 5 ? 2 : VAL;

    return VAL;
  }
}
